import { combineReducers } from "redux";
import themeReducer from "./theme-behavior";
import layoutsReducer from "./layouts-behavior";
import settingsReducer from "./settings-behavior";
import menusReducer from "./menu-behavior";
import treeReducer from "./tree-behavior";
import searchReducer from "./search-behavior";
import userPreferenceReducer from "./user-preference-behavior";
import websocketReducer from "./websocket-behavior";
import userReducer from "./user-behavior";
import adminReducer from "./admin-behavior";
import selectionOptionReducer from "./selection-options-behavior";
import customFieldsReducer from "./custom-fields-behavior";
import taxonomyReducer from "./taxonomy-behavior";
import editorReducer from "./editor-behavior";
import itemMappingsReducer from "./item-mappings-behavior.js";
import screenSizeReducer from "./screen-size-behavior.js";
import globalAlertReducer from "./global-alert-behavior.js";

export default combineReducers({
  globalAlert:globalAlertReducer,
  theme: themeReducer,
  layout: layoutsReducer,
  setting: settingsReducer,
  menu: menusReducer,
  tree: treeReducer,
  search: searchReducer,
  prefs: userPreferenceReducer,
  websocket: websocketReducer,
  user: userReducer,
  admin: adminReducer,
  selectionOption: selectionOptionReducer,
  customFields: customFieldsReducer,
  taxonomy: taxonomyReducer,
  editor: editorReducer,
  itemMappings: itemMappingsReducer,
  screen: screenSizeReducer,
});
